"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./RatingStars.scss");

require("./RatingStarsDark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RatingStars = function RatingStars(_ref) {
  var count = _ref.count,
      isHalf = _ref.isHalf,
      icon = _ref.icon,
      size = _ref.size,
      onChange = _ref.onChange,
      value = _ref.value;

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      rating = _useState2[0],
      setRating = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var isEnd = function isEnd(number) {
    return number % 2 === 0;
  };

  var internalCount = isHalf ? count * 2 : count;

  var getArray = function getArray() {
    var array = [];
    var plus = isHalf ? 2 : 1;

    for (var index = 1; index <= internalCount; index += plus) {
      array.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: 'gcl-rating-container'
      }, getButton(index), isHalf && getButton(index + 1)));
    }

    return array.map(function (v) {
      return v;
    });
  };

  var getButton = function getButton(index) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      key: index,
      className: "gcl-ritem ".concat(index <= (hover || rating) ? 'on' : 'off', " ").concat(isHalf ? isEnd(index) ? 'end' : 'start' : '', " ").concat(size),
      onClick: function onClick() {
        onChange(isHalf ? index / 2 : index);
        setRating(index);
      },
      onMouseEnter: function onMouseEnter() {
        return setHover(index);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(rating);
      }
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: 'gcl-icon ' + icon
    }));
  };

  (0, _react.useEffect)(function () {
    setRating(isHalf ? value * 2 : value);
    setHover(isHalf ? value * 2 : value);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-rating"
  }, getArray());
};

RatingStars.propTypes = {
  icon: _propTypes["default"].string,
  halfIcon: _propTypes["default"].string,
  isHalf: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['small', 'large', ''])
};
RatingStars.defaultProps = {
  icon: 'star',
  halfIcon: '',
  isHalf: false,
  size: '',
  value: 0
};
var _default = RatingStars;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/RatingStars/RatingStars.js
// module id = 1911
// module chunks = 0